import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import { getErrorMsg } from '../../../common/helpers/translations'
import { scrollToTop } from '../../../common/helpers/scroll'
import { getWhoAmI } from '../../../common/auth/authActions'
import { buildScopeFromFeatures } from '../../../common/helpers/featureFlags'
import { updateSuperAdminTargetCompanyInfo } from '../../SuperAdmin/store/SuperAdminActions'
import {
  getCompanyFeatureFlags,
  getCompanyFeatureFlagsSuccess,
  getCompanyFeatureFlagsFail,
  updateCompanyFeatureFlags,
  updateCompanyFeatureFlagsSuccess,
  updateCompanyFeatureFlagsFail,
} from './FeaturesAdminActions'

function* sagaGetCompanyFeatureFlags({ payload }: any) {
  try {
    const { companyId } = payload
    const response: any = yield call(api.auth.getCompanyFeatureFlags, { companyId })
    yield put({ type: String(getCompanyFeatureFlagsSuccess), payload: response })

    // Update target company scope when managing a foreign company as super admin
    const state: any = yield select()
    const targetCompany = state.superAdmin?.targetCompany
    if (targetCompany && targetCompany.companyId === companyId) {
      const scope = buildScopeFromFeatures(response?.features || [])
      yield put(updateSuperAdminTargetCompanyInfo({ scope }))
    }
  } catch (e: any) {
    yield put({ type: String(getCompanyFeatureFlagsFail) })
    const notification: INotification = {
      type: 'warning',
      content: getErrorMsg('getCompanyFeatureFlags'),
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

function* sagaUpdateCompanyFeatureFlags({ payload }: any) {
  try {
    yield call(api.auth.updateCompanyFeatureFlags, payload)
    yield put({ type: String(updateCompanyFeatureFlagsSuccess) })

    const notification: INotification = {
      type: 'success',
      content: t`Feature flags updated.`,
    }
    yield put({ type: String(addNotification), payload: notification })
    scrollToTop()

    // Reload flags to get the latest state
    yield put({ type: String(getCompanyFeatureFlags), payload: { companyId: payload.companyId } })
    // Refresh session so updated scopes take effect
    yield put({ type: String(getWhoAmI) })
  } catch (e: any) {
    yield put({ type: String(updateCompanyFeatureFlagsFail) })

    let errorContent: any
    if (e.message === 'invalidSecret') {
      errorContent = t`Invalid secret key.`
    } else {
      errorContent =
        e.message && e.message !== 'No message has been provided by the server'
          ? e.message
          : getErrorMsg('updateCompanyFeatureFlags')
    }

    const notification: INotification = {
      type: 'warning',
      content: errorContent,
    }
    yield put({ type: String(addNotification), payload: notification })
    scrollToTop()
  }
}

export function* featuresAdminSagas() {
  yield all([
    takeEvery(String(getCompanyFeatureFlags), sagaGetCompanyFeatureFlags),
    takeEvery(String(updateCompanyFeatureFlags), sagaUpdateCompanyFeatureFlags),
  ])
}
